/**
 * BetterAuth React client singleton.
 *
 * Plugins on the client mirror the server-side BetterAuth plugins that
 * have client-side counterparts: twoFactor, organization, adminClient
 * (for impersonation UI), multiSession (for the sessions list in account
 * settings). haveIBeenPwned is server-only — no client equivalent needed.
 *
 * baseURL points at the API host root. VITE_API_BASE_URL is the full
 * /api/v1 base (e.g. http://localhost:3001/api/v1) — we strip the
 * /api/v1 suffix because BetterAuth wants the host root and mounts
 * itself at /api/auth.
 */
import { createAuthClient } from 'better-auth/react';
import {
  twoFactorClient,
  organizationClient,
  adminClient,
  multiSessionClient,
} from 'better-auth/client/plugins';

const apiV1 = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1';
const baseURL = apiV1.replace(/\/api\/v1\/?$/, '');

export const authClient = createAuthClient({
  baseURL,
  plugins: [twoFactorClient(), organizationClient(), adminClient(), multiSessionClient()],
});

// Re-exports for ergonomic imports across the app.
export const { useSession, signIn, signUp, signOut, getSession } = authClient;
